import { GetterTree } from 'vuex'
import { EventStateInterface } from 'src/store/event/state'
import { StoreInterface } from 'src/store'
import { Event } from 'able-lib'

const getters: GetterTree<EventStateInterface, StoreInterface> = {

  getEvents: (state: EventStateInterface): Event[] => state.events
}

export default getters
